import type { Types as OData } from 'shared/odata'

import { Exclude } from 'features/contacts/ui/Exclude/Exclude'
import {
	$executionsColumns,
	$executionsStyles,
	Column,
	columnHeaders
} from 'features/contacts/utils/columns'
import * as files from 'shared/files'
import {
	ContactsTable,
	LoadingButton,
	SearchPagination,
	StackIcon
} from 'shared/ui'

import type { Execution } from '../../types'

import { api } from '../../api'
import { InfoPopup } from '../Actions/Info'
import { StopModal } from '../Actions/Stop'
import { InteractionLog } from '../InteractionLog/InteractionLog'
import { Cells } from './adapters'

const sortKeys: Partial<Record<Column, string>> = {
	[Column.Added]: 'created',
	[Column.Contact]: 'linkedin_contact/full_name',
	[Column.Custom1]: 'linkedin_contact/custom_field_1',
	[Column.Custom2]: 'linkedin_contact/custom_field_2',
	[Column.Custom3]: 'linkedin_contact/custom_field_3',
	[Column.Headline]: 'linkedin_contact/occupation',
	[Column.Imported]: 'linkedin_contact/imported',
	[Column.LastAction]: 'linkedin_contact/contacted',
	[Column.Location]: 'linkedin_contact/location'
}

const Headers = () => [
	<ContactsTable.SortableHeadCells
		allowedKeys='Executions'
		columnsStore={$executionsColumns}
		headlineDictionary={columnHeaders}
		key='🎩s'
		sortDictionary={sortKeys}
	/>,
	ContactsTable.ActionTH
]

function ExportButton({
	filters,
	unSelectAll
}: Pick<ContactsTable.Types.ActionsProps, 'filters' | 'unSelectAll'>) {
	const [fetchCSV, { isLoading }] = api.useExportExecutionsMutation()
	return (
		<LoadingButton
			className={ContactsTable.css.activeControlButton}
			isLoading={isLoading}
			onClick={async () => {
				const { $filter, $orderby, $searchQuery } = filters

				const { data: content } = await fetchCSV({
					$filter,
					$orderby,
					$searchQuery
				})

				unSelectAll()

				if (content) {
					files.saveFile(content, files.generateName())
				}
			}}
			variant='bordered-dark'
		>
			<StackIcon icon='csv' width={18} />
			Export Contacts
		</LoadingButton>
	)
}

const HeaderActions = (props: ContactsTable.Types.ActionsProps) => [
	<InteractionLog
		className={ContactsTable.css.activeControlButton}
		{...props}
		key='📦'
	/>,
	<ExportButton {...props} key='➕' />,
	<Exclude {...props} key='➖' />
]

export function Table({
	filter,
	items,
	total = 0
}: {
	filter: Partial<OData.Page>
	items: Execution[]
	total?: number
}) {
	return (
		<>
			<ContactsTable.Wrapper sizeKey='Executions' store={$executionsStyles}>
				<ContactsTable.SelectWrap
					Actions={HeaderActions}
					filter={filter}
					Headers={Headers}
					items={items}
					Row={Cells}
					total={total}
				/>
			</ContactsTable.Wrapper>

			<InfoPopup />
			<StopModal />
			<SearchPagination total={total} />
		</>
	)
}
